/**
 * 家族関係型定義
 */
export interface FamilyRelation {
  relationId: string; // 相手のNPC ID
  relationType: 'parent' | 'child' | 'partner';
  since: number; // 関係開始日
}

/**
 * 家族関係作成
 */
export function createFamilyRelation(
  relationId: string,
  relationType: 'parent' | 'child' | 'partner',
  day: number
): FamilyRelation {
  return {
    relationId,
    relationType,
    since: day,
  };
}
